import { CircularProgress } from '@tempmee/react';
import { CenteredSpinner } from '~/commonComponents';
import { Colors } from '../../themes/colors';
import { Box } from '../Box';

interface IProps {
  tableRef?: React.RefObject<HTMLTableElement>;
  data: any[];
  renderRow: (item: any) => React.ReactNode;
  headerTitles: string[];
  onRowClick?: (item: any) => void;
  showActions?: boolean;
  isLoading?: boolean;
  PaginationComponent?: () => React.ReactNode;
  dataKey?: string;
  dataCy?: string;
  rowDataCy?: string;
}

export const Table = ({
  tableRef,
  data,
  renderRow,
  headerTitles,
  onRowClick,
  showActions = false,
  isLoading,
  PaginationComponent,
  dataKey,
  dataCy,
  rowDataCy,
}: IProps) => (
  <div style={{ position: 'relative' }}>
    <table
      ref={tableRef}
      data-cy={dataCy}
      style={{
        width: '100%',
        borderCollapse: 'collapse',
      }}
    >
      <thead
        style={{
          borderBottomWidth: 1,
          borderBottomStyle: 'solid',
          borderBottomColor: Colors.neutral_100,
        }}
      >
        <tr>
          {headerTitles?.map((title) => (
            <th
              key={title}
              style={{
                fontFamily: 'Nunito',
                fontSize: 18,
                fontWeight: 700,
                color: Colors.primary_500,
                textAlign: 'center',
                paddingBottom: 8,
                borderBottomWidth: 1,
                maxWidth: 100,
                borderBottomStyle: 'solid',
                borderBottomColor: Colors.neutral_100,
                width: 'fit-content',
              }}
            >
              {title}
            </th>
          ))}
          {showActions && (
            <th
              style={{
                cursor: 'default',
                opacity: 0,
              }}
            >
              Action
            </th>
          )}
        </tr>
      </thead>
      <tbody>
        <tr style={{ height: 10 }} />
        {data.map((item) => (
          <tr
            style={{
              height: 64,
              borderBottomWidth: 1,
              borderBottomStyle: 'solid',
              borderBottom: `1px solid ${Colors.neutral_100}`,
              cursor: onRowClick ? 'pointer' : 'default',
            }}
            key={dataKey ? item[dataKey] : item}
            onClick={() => onRowClick?.(item)}
            data-cy={rowDataCy}
          >
            {renderRow(item)}
          </tr>
        ))}
      </tbody>
    </table>

    {PaginationComponent && (
      <Box marginTop={32}>
        <PaginationComponent />
      </Box>
    )}

    {PaginationComponent && isLoading && (
      <div
        style={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'rgba(255, 255, 255, 0.7)',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'flex-start',
        }}
      >
        <CircularProgress />
      </div>
    )}

    {!PaginationComponent && isLoading && (
      <div style={{ marginTop: 20 }}>
        <CenteredSpinner />
      </div>
    )}
  </div>
);
